import { render, staticRenderFns } from "./TxGraphCanvas.vue?vue&type=template&id=4c4f531a&scoped=true"
import script from "./TxGraphCanvas.vue?vue&type=script&lang=js"
export * from "./TxGraphCanvas.vue?vue&type=script&lang=js"
import style0 from "./TxGraphCanvas.vue?vue&type=style&index=0&id=4c4f531a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f531a",
  null
  
)

export default component.exports